<template>
  <div>
    <el-popover
        :popper-class="msgPopperClass"
        trigger="hover">
      <div class="is-error-msg">
        {{ errorMsg }}
      </div>
      <el-date-picker
          ref="input"
          slot="reference"
          v-model="dateValue"
          :class="{'is-error': errorMsg }"
          :readonly="readonly"
          :disabled="disabled"
          :size="size"
          :clearable="clearable"
          :placeholder="placeholder"
          :start-placeholder="startPlaceholder"
          :end-placeholder="endPlaceholder"
          :type="pickerType"
          :default-time="defaultTime"
          :default-value="defaultValue"
          :align="align"
          :value-format="valueFormat"
          @focus="onFocus"
          @blur="onBlur" />
    </el-popover>
    <div v-show="!popoverErrorMsg && errorMsg"
        class="is-error-msg">
      {{ errorMsg }}
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import Vue from 'vue'
import ValidCore from '@/components/atoms/BaseValidCore'

export default {
  name: 'BaseValidDatePicker',
  mixins: [ValidCore],
  props: {
    //  Attributes
    readonly: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    size: {
      type: String,
      default: undefined,
      validator: function (value) {
        return ['large', 'small', 'mini'].indexOf(value) !== -1
      }
    },
    clearable: { type: Boolean, default: true },
    placeholder: { type: String, default: '日付を選択してください' },
    startPlaceholder: { type: String, default: '日付を選択してください' },
    endPlaceholder: { type: String, default: '日付を選択してください' },
    type: {
      type: String,
      default: undefined,
      validator: function (value) {
        // return ['year', 'month', 'date', 'dates', 'datetime', 'week', 'datetimerange', 'daterange'].indexOf(value) !== -1;
        return ['year', 'date', 'datetime', 'datetimerange', 'daterange', 'timestamp_date', 'timestamp_datetime'].indexOf(value) !== -1
      }
    },
    defaultTime: { type: Array, default: () => null },
    defaultValue: { type: String, default: null },
    align: {
      type: String,
      default: undefined,
      validator: function (value) {
        return ['left', 'center', 'right'].indexOf(value) !== -1
      }
    }

    // TODO 以下はel-date-picker標準のprops.
    // TODO 使わないかもしれないが一旦コメントアウトして残しておく. いずれ削除すること.
    // format: { type: String, default: undefined },
    // popperClass: { type: String, default: undefined },
    // pickerOptions: { type: Object, default: () => { return {}; } },
    // rangeSeparator: { type: String, default: '-' },
    // defaultValue: { type: Date, default: undefined },
    // defaultTime: { type: Array, default: undefined },
    // valueFormat: { type: String, default: undefined },
    // unlinkPanels: { type: Boolean, default: false },
    // prefixIcon: { type: String, default: undefined },
    // clearIcon: { type: String, default: undefined },
  },
  data () {
    return {
      whenFocused: null
    }
  },
  computed: {
    dateValue: {
      get: function () {
        const toTimezoneDatetime = (val) => {
          return val ? Vue.moment.tz(val, this.timezone).format() : ''
        }
        if (Array.isArray(this.inputValue)) {
          return this.inputValue.reduce((acc, cur) => {
            acc.push(toTimezoneDatetime(cur))
            return acc
          }, [])
        } else if (this.valueFormat === 'timestamp') {
          return this.inputValue
        } else {
          const result = toTimezoneDatetime(this.inputValue)
          return result.toString() === 'Invalid date' ? '' : result
        }
      },
      set: function (newValue) {
        let utcDate
        const toUtcDatetime = (val) => {
          return val ? Vue.moment.tz(val, this.momentDatetimeFormat, this.timezone).utc().format() : ''
        }
        if (Array.isArray(newValue)) {
          utcDate = newValue.reduce((acc, cur) => {
            acc.push(toUtcDatetime(cur))
            return acc
          }, [])
        } else if (this.valueFormat === 'timestamp') {
          utcDate = newValue
        } else {
          utcDate = toUtcDatetime(newValue)
        }
        this.updateInputValue(utcDate)
      }
    },
    pickerType () {
      switch (this.type) {
        case 'timestamp_date':
          return 'date'
        case 'timestamp_datetime':
          return 'datetime'
        default:
          return this.type
      }
    },
    valueFormat () {
      switch (this.type) {
        case 'timestamp_date':
        case 'timestamp_datetime':
          return 'timestamp'
        case 'year':
          return 'yyyy'
        case 'datetime':
        case 'datetimerange':
          return 'yyyy-MM-ddTHH:mm:ss'
        case 'date':
        default:
          return 'yyyy-MM-dd'
      }
    },
    momentDatetimeFormat () {
      switch (this.type) {
        case 'timestamp_date':
          return 'YYYY/MM/DD'
        case 'timestamp_datetime':
          return 'YYYY/MM/DD HH:mm:ss'
        case 'year':
          return 'YYYY'
        case 'datetime':
        case 'datetimerange':
          return 'YYYY/MM/DD HH:mm:ss'
        case 'date':
        default:
          return 'YYYY/MM/DD'
      }
    },
    timezone () {
      return this.$store.state.timeZone
    }
  },
  methods: {
    onFocus (event) {
      this.whenFocused = _.cloneDeep(this.inputValue)
      this.$emit('focus', event)
    },
    onBlur (event) {
      this.$emit('blur', event, this.whenFocused, this.inputValue)
    }
  }
}
</script>
